"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.services = void 0;
var qs = require('qs');
exports.services = function (axios) {
    return {
        getServicesMe: function () {
            return axios.get('/services/me');
        },
        getServiceTemp: function (getServicesTempRequest) {
            var query = qs.stringify(getServicesTempRequest.params);
            return axios.get("/services/temp?" + query);
        },
        getServiceChatbot: function (request) {
            return axios.get("/admins/service/chatbot?mallNo=" + request.params.mallNo);
        },
        putServicesTemp: function (putServicesTempRequest) {
            return axios.put('/services/temp', putServicesTempRequest.data);
        },
        getServicesByServiceNo: function (getServicesByServiceNoRequest) {
            return axios.get("/services/" + getServicesByServiceNoRequest.params.serviceNo);
        },
        putServicesByServiceNo: function (request) {
            return axios.put("/services/" + request.params.serviceNo, request.data);
        },
        patchServicesByServiceNo: function (request) {
            return axios.patch("/services/" + request.params.serviceNo, request.data);
        },
        getServicesByServiceNoDeliveryPartner: function (request) {
            return axios.get("/services/" + request.params.serviceNo + "/delivery-partner");
        },
        getServicesByServiceNoSecurityConfiguration: function (request) {
            return axios.get("/services/" + request.params.serviceNo + "/security-configuration");
        },
        putServicesByServiceNoSecurityConfiguration: function (request) {
            return axios.put("/services/" + request.params.serviceNo + "/security-configuration", request.data);
        },
        getServicesServiceNoLogoutConfig: function (request) {
            return axios.get("/services/" + request.params.serviceNo + "/logout-config");
        },
        putServicesServiceNoLogoutConfig: function (request) {
            return axios.put("/services/" + request.params.serviceNo + "/logout-config", request.data);
        },
        getPartnersServiceNoLogoutConfig: function (request) {
            return axios.get("/partners/" + request.params.partnerNo + "/logout-config");
        },
        putPartnersServiceNoLogoutConfig: function (request) {
            return axios.put("/partners/" + request.params.partnerNo + "/logout-config", request.data);
        },
    };
};
